"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportTravelTimeStep = void 0;
const react_i18next_1 = require("react-i18next");
const context_1 = require("../../../../../components/UnscheduledWorkWorkflow/context");
const react_1 = __importStar(require("react"));
const useReportTravelTimeStep = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { travelStartDate, travelStartTime, travelEndDate, travelEndTime, setTotalSteps, setCurrentStepTitle, setIsCurrentStepValid, setShowErrorFallback, setIsActionable, reasonForTravel, mealBreakStartTime, mealBreakEndTime, setIsMealBreakApplicable, mealBreakDuration, isMealBreakApplicable } = (0, context_1.useUnscheduledWorkflowContext)();
    const [newTravelStartTime, setNewTravelStartTime] = (0, react_1.useState)(travelStartTime || '');
    const [newTravelStartDate, setNewTravelStartDate] = (0, react_1.useState)(travelStartDate);
    const [newTravelEndTime, setNewTravelEndTime] = (0, react_1.useState)(travelEndTime || '');
    const [newTravelEndDate, setNewTravelEndDate] = (0, react_1.useState)(travelEndDate);
    const [newMealBreakStartTime, setNewMealBreakStartTime] = (0, react_1.useState)(mealBreakStartTime || '');
    const [newIsMealBreakApplicable, setNewIsMealBreakApplicable] = (0, react_1.useState)(isMealBreakApplicable);
    const [newMealBreakDuration, setNewMealBreakDuration] = (0, react_1.useState)(mealBreakDuration);
    const [newMealBreakEndTime, setNewMealBreakEndTime] = (0, react_1.useState)(mealBreakEndTime || '');
    const [newReasonForTravel, setNewReasonForTravel] = (0, react_1.useState)(reasonForTravel || '');
    const [hasInputError, setHasInputError] = react_1.default.useState(false);
    const [inputErrorMessage, setInputErrorMessage] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        setTotalSteps(2);
        setCurrentStepTitle(t('unscheduled_work_report_travel_time_form_heading'));
        setShowErrorFallback(false);
        setIsActionable(true);
        setIsMealBreakApplicable(isMealBreakApplicable);
        return () => {
            setIsActionable(true);
        };
    }, []);
    const hasValidStartAndEndDate = () => {
        return (newTravelStartDate === null || newTravelStartDate === void 0 ? void 0 : newTravelStartDate.isValid) && (newTravelEndDate === null || newTravelEndDate === void 0 ? void 0 : newTravelEndDate.isValid);
    };
    const hasValidStartAndEndTime = () => {
        return !!newTravelStartTime && !!newTravelEndTime;
    };
    const hasMealBreakApplicableInfo = () => {
        if (!isMealBreakApplicable)
            return true;
        return (isMealBreakApplicable &&
            ((!!newMealBreakStartTime && !!newMealBreakEndTime) ||
                (!newMealBreakStartTime && !newMealBreakEndTime)));
    };
    const checkIfCurrentStepIsValid = () => {
        return (!hasInputError &&
            hasValidStartAndEndDate() &&
            hasValidStartAndEndTime() &&
            hasMealBreakApplicableInfo() &&
            !!newReasonForTravel);
    };
    (0, react_1.useEffect)(() => {
        setIsCurrentStepValid(checkIfCurrentStepIsValid());
    }, [
        newTravelStartTime,
        newTravelStartDate,
        newTravelEndTime,
        newTravelEndDate,
        newMealBreakStartTime,
        newMealBreakDuration,
        newMealBreakEndTime,
        isMealBreakApplicable,
        newReasonForTravel,
        hasInputError
    ]);
    const inputLabel = null;
    return {
        newTravelStartDate,
        newTravelStartTime,
        newTravelEndDate,
        newTravelEndTime,
        newMealBreakStartTime,
        newMealBreakEndTime,
        setNewMealBreakEndTime,
        newIsMealBreakApplicable,
        setNewIsMealBreakApplicable,
        newMealBreakDuration,
        setNewMealBreakDuration,
        newReasonForTravel,
        setNewTravelStartDate,
        setNewTravelEndDate,
        setNewTravelEndTime,
        setNewTravelStartTime,
        setNewMealBreakStartTime,
        setNewReasonForTravel,
        hasInputError,
        setHasInputError,
        inputErrorMessage,
        setInputErrorMessage,
        inputLabel
    };
};
exports.useReportTravelTimeStep = useReportTravelTimeStep;
